export const SORT_OPTIONS = [
  { sortKey: "classification", translationKey: "label.classification" },
  { sortKey: "createdDate", translationKey: "label.created" },
  { sortKey: "updatedDate", translationKey: "label.updated" },
  { sortKey: "opportunityType", translationKey: "label.type" },
  { sortKey: "status", translationKey: "label.status" },
  { sortKey: "value", translationKey: "label.value" },
] as const;

export const SORT_KEY_LABEL: Record<string, string> = Object.fromEntries(
  SORT_OPTIONS.map(({ sortKey, translationKey }) => [sortKey, translationKey])
);
